export default "__VITE_ASSET___wYcgnWc__"